import { useDispatch, useSelector } from 'react-redux';
import { EditableQuestion } from '../../../../../../../types';
import { setQuestions } from '../../../../../../../../../redux/questionnaire/actions';
import { selectQuestions } from '../../../../../../../../../redux/questionnaire/selectors';
import { useEditing } from '../../../../QuestionContainer/hooks/useEditing';

export const useDeleteQuestion = (question: EditableQuestion) => {
  const questions = useSelector(selectQuestions);
  const { cancelEditing } = useEditing(question);
  const dispatch = useDispatch();

  const handleDeleteQuestion = () => {
    dispatch(setQuestions(removeQuestionFromArray(questions, question)));
    cancelEditing();
  };

  return handleDeleteQuestion;
};

const removeQuestionFromArray = (questions: EditableQuestion[], questionToRemove: EditableQuestion) => {
  return questions.filter(question => question._id !== questionToRemove._id);
};
